<template>
	<AppList :items="typeof socials !== 'undefined' ? socials : []" class="social-container-list">
		<template v-slot:social-dropdown="{item}">
			<div class="row flex-end">
				<AppTextInput :value="item.value" placeholder="username" @changed-text="(value) => validateSocialField(value, item)" />
			</div>
		</template>
	</AppList>
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import {validateSocial} from "@/console-new/helpers/validation";
import {useSocialsStore, useUserStore} from "@/console-new/stores";

export default {
	setup() {
		let socialsStore = useSocialsStore();
		let userStore = useUserStore();
		return {userStore, socialsStore};
	},
	name: "SocialsList",
	components: {AppTextInput, AppList},
	data() {
		return {
			socials: this.storeSocials,
		}
	},
	computed: {
		storeSocials() {
			return this.socialsStore.businessSocials.map(social => {
				return {
					title: social.type,
					switch: true,
					active: !!social.value,
					value: social.value ? social.value : "",
					dropdownSlot: "social-dropdown",
				}
			});
		}
	},
	methods: {
		validateSocialField(value, item) {
			item.value = validateSocial(value, item.title);
		},
		getSocialCollection() {
			let result = {};
			this.socials.forEach(social => {
				if (social.active) {
					result[social.title] = social.value;
				}
			});
			return result;
		}
	},
	created() {
		if(this.userStore.currBusinessId !== null) {
			this.socialsStore.refreshSocials();
		}
	},
	watch: {
		"socialsStore.businessSocials"() {
			this.socials = this.storeSocials;
		},
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== null && newVal !== oldVal) {
				this.socialsStore.refreshSocials();
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.social-container-list :deep(.list-item-title) {
	text-transform: capitalize;
}
</style>